$('.product-trusted-list-wrapper').slick({
  speed: 300,
  slidesToShow: 1,
  variableWidth: true,
  prevArrow: $('.trusted-slider-prev'),
  nextArrow: $('.trusted-slider-next')
});

$('.google-rating-slider').slick({
  dots: true,
  appendDots: $('.slider-dots'),
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  prevArrow: '.google-rating-slider-buttons .prev-button',
  nextArrow: '.google-rating-slider-buttons .next-button'
});

// $('.visit-us-wrapper').slick({
//   dots: true,
//   appendDots: $('.about-us-dots'),
//   infinite: false,
//   speed: 300,
//   slidesToShow: 1,
//   // asNavFor: '.about-us-image-wrapper',
//   prevArrow: '.about-us-buttons .prev-button',
//   nextArrow: '.about-us-buttons .next-button'
// });

// $('.about-us-image-wrapper').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   asNavFor: '.visit-us-wrapper',
//   arrows: false,
//   fade: true,
// });

// $(".moving-banner").slick({
//   speed: 8000,
//   autoplay: true,
//   autoplaySpeed: 0,
//   centerMode: false,
//   cssEase: 'linear',
//   slidesToShow: 1,
//   draggable: false,
//   focusOnSelect: false,
//   pauseOnFocus: false,
//   pauseOnHover: false,
//   slidesToScroll: 1,
//   variableWidth: true,
//   infinite: true,
//   initialSlide: 1,
//   arrows: false,
//   buttons: false
// });

$(window).on('resize', function () {
  // Check if the condition matches for applying slick
  if (window.matchMedia("only screen and (max-width: 768px)").matches) {
    // Initialize slick if not already initialized
    if (!$(".why-choose_list").hasClass('slick-initialized')) {
      $(".why-choose_list").slick({
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        slidesToShow: 1,
        draggable: false,
        focusOnSelect: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
      });
    }
  } else {
    // Destroy slick if the screen is wider than 768px and slick is initialized
    if ($(".why-choose_list").hasClass('slick-initialized')) {
      $(".why-choose_list").slick('unslick');
    }
  }
}).trigger('resize');

// Add an "Actual photos of the product" caption beside the zoom button in the
// product image lightbox (PhotoSwipe). Hooked in via MutationObserver instead of
// editing theme.js directly, since the lightbox UI is built by the compiled bundle.
(function () {
  var observer = new MutationObserver(function () {
    document.querySelectorAll('.pswp__top-bar').forEach(function (topBar) {
      if (topBar.querySelector('.pswp__zoom-caption')) return;
      var zoomButton = topBar.querySelector('.pswp__button--zoom');
      if (!zoomButton) return;
      var caption = document.createElement('span');
      caption.className = 'pswp__zoom-caption';
      caption.textContent = 'Actual photos of the product';
      topBar.insertBefore(caption, zoomButton);
    });

    document.querySelectorAll('.pswp--product-lightbox').forEach(function (pswp) {
      if (pswp.querySelector('.pswp__zoom-caption-mobile')) return;
      var caption = document.createElement('span');
      caption.className = 'pswp__zoom-caption-mobile';
      caption.textContent = 'Actual photos of the product';
      pswp.appendChild(caption);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
